import { GlButton, GlTooltipDirective } from '@gitlab/ui';
import { sprintf, s__ } from '~/locale';
import { InternalEvents } from '~/tracking';
import ImplementationWidgetSegment from 'ee/vue_shared/components/work_items/implementation_widget_segment.vue';
import ReadinessBar from './readiness_bar.vue';
import ReadinessDrawer from './readiness_drawer.vue';
import { PLAN_READINESS_LEVELS, READINESS_SCORE_MEDIUM_THRESHOLD, READINESS_SCORE_HIGH_THRESHOLD } from './constants';
export default {
    name: 'WorkItemReadiness',
    components: {
        ImplementationWidgetSegment,
        ReadinessBar,
        GlButton,
        ReadinessDrawer
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        score: {
            type: Number,
            required: true
        },
        isDrawerOpen: {
            type: Boolean,
            required: true
        },
        feedbackHtml: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'toggle',
        'close'
    ],
    data () {
        return {
            hasTrackedScoreView: false
        };
    },
    computed: {
        readinessLevel () {
            if (this.score < READINESS_SCORE_MEDIUM_THRESHOLD) return PLAN_READINESS_LEVELS.LOW;
            if (this.score < READINESS_SCORE_HIGH_THRESHOLD) return PLAN_READINESS_LEVELS.MEDIUM;
            return PLAN_READINESS_LEVELS.HIGH;
        },
        readinessLevelText () {
            return this.$options.readinessLevelText[this.readinessLevel.value];
        },
        ariaLabel () {
            return sprintf(s__('AgentPlan|Readiness: %{level}'), {
                level: this.readinessLevelText
            });
        }
    },
    methods: {
        trackScoreViewed () {
            if (this.hasTrackedScoreView) return;
            this.hasTrackedScoreView = true;
            this.trackEvent('view_work_item_agent_plan_readiness_score', {
                value: this.score
            });
        },
        closeDrawer () {
            this.$emit('close');
            this.$refs.toggle.$el.focus();
        }
    },
    readinessLevelText: {
        [PLAN_READINESS_LEVELS.LOW.value]: s__('AgentPlan|Low'),
        [PLAN_READINESS_LEVELS.MEDIUM.value]: s__('AgentPlan|Medium'),
        [PLAN_READINESS_LEVELS.HIGH.value]: s__('AgentPlan|High')
    }
};
